import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse, PaginatedApiResponse } from '@card-software/nexus-utilities';
import { KnittingOrderReportItem } from '@app/models/knitting/kntiting-requistion-report';
import { environment } from '../../../environments/environment';
import { KnittingOrder, KnittingOrderSearchCommand } from '../../models/production/knitting-order';

@Injectable({
  providedIn: 'root',
})
export class KnittingOrderProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.productionApi + '/api/v1/knitting-order';

  getknittingorder(): Observable<ApiResponse<KnittingOrder[]>> {
    return this.httpClient.get<ApiResponse<KnittingOrder[]>>(`${this.baseUrl}/all`);
  }
  getKnittingOrderById(id: string): Observable<ApiResponse<KnittingOrder>> {
    return this.httpClient.get<ApiResponse<KnittingOrder>>(`${this.baseUrl}/${id}`);
  }
  getKnittingOrderByIdAndFabricCode(id: string, fabricCode: string): Observable<ApiResponse<KnittingOrder>> {
    return this.httpClient.get<ApiResponse<KnittingOrder>>(`${this.baseUrl}/${id}/fabric/${encodeURIComponent(fabricCode)}`);
  }
  createKnittingOrder(knittingorders: KnittingOrder): Observable<ApiResponse<KnittingOrder>> {
    return this.httpClient.post<ApiResponse<KnittingOrder>>(this.baseUrl, knittingorders);
  }
  updateKnittingOrder(knittingorder: KnittingOrder): Observable<ApiResponse<KnittingOrder>> {
    return this.httpClient.put<ApiResponse<KnittingOrder>>(`${this.baseUrl}/${knittingorder.id!}`, knittingorder);
  }

  searchKnittingOrder(
    command: KnittingOrderSearchCommand,
    pageNumber = 1,
    pageSize = 25,
    includeRollBreakdown = false,
    sortField?: string,
    sortOrder = -1,
  ): Observable<ApiResponse<PaginatedApiResponse<KnittingOrder>>> {
    let queryParams = `?pageNumber=${pageNumber}&pageSize=${pageSize}&includeRollBreakdown=${includeRollBreakdown}`;
    if (sortField) {
      queryParams += `&sortField=${sortField}&sortOrder=${sortOrder}`;
    }
    return this.httpClient.post<ApiResponse<PaginatedApiResponse<KnittingOrder>>>(`${this.baseUrl}/search${queryParams}`, command);
  }

  updateKnittingOrderStatus(id: string, newStatus: number): Observable<ApiResponse<boolean>> {
    return this.httpClient.patch<ApiResponse<boolean>>(`${this.baseUrl}/${id}/status`, newStatus);
  }
  public getYarnBalanceByKnittingOrderIds(ids: string[]): Observable<ApiResponse<KnittingOrderReportItem[]>> {
    return this.httpClient.post<ApiResponse<KnittingOrderReportItem[]>>(`${this.baseUrl}/requisition-data/batch`, ids);
  }
}
